export default "__VITE_ASSET__OZvM0jK0__"